export default __webpack_public_path__ + "static/media/b_vision_mision_small.6acd2e91.jpg";